// DO NOT EDIT THIS FILE!
// This file was generated by ubi-generators (https://ghe.spotify.net/datainfra/ubi-generators).
// For support, contact us on the #ubi-users Slack channel.
const SPECIFICATION_ID = "web-support-contact-us-article";
const APP = "support-spotify-com";
const SPECIFICATION_VERSION = "1.0.0";
const SPECIFICATION_MODE = "default";
const GENERATOR_VERSION = "16.0.1";
/**
 * Creates an event factory to generate events
 * @params options - The required context for this specification
 * @returns {WebSupportContactUsArticleEventFactory} A new instance of WebSupportContactUsArticleEventFactory
 */
export function createWebSupportContactUsArticleEventFactory(options) {
    return new WebSupportContactUsArticleEventFactory(options);
}
/**
 * Contact us article is the new contact us page, that replaces the old article with a form and CTA after completing the form.
 */
export class WebSupportContactUsArticleEventFactory {
    constructor(options) {
        this._path = [{
                name: SPECIFICATION_ID
            }];
        if (options?.parentAbsoluteLocation) {
            this._parentAbsoluteLocation = options.parentAbsoluteLocation;
        }
    }
    /**
     * Creates a new instance of TopLevelIntentRadioButtonEventFactory
     * @param {Object} data - The required metadata for this element node.
     * @param {string} data.identifier- intent id
     * @returns {TopLevelIntentRadioButtonEventFactory}  A new instance of TopLevelIntentRadioButtonEventFactory
     */
    topLevelIntentRadioButtonFactory(data) {
        return new WebSupportContactUsArticleEventFactory.TopLevelIntentRadioButtonEventFactory({
            path: this._path,
            parentAbsoluteLocation: this._parentAbsoluteLocation,
            data
        });
    }
    /**
     * Creates a new instance of SecondLevelIntentRadioButtonEventFactory
     * @param {Object} data - The required metadata for this element node.
     * @param {string} data.identifier- intent id
     * @returns {SecondLevelIntentRadioButtonEventFactory}  A new instance of SecondLevelIntentRadioButtonEventFactory
     */
    secondLevelIntentRadioButtonFactory(data) {
        return new WebSupportContactUsArticleEventFactory.SecondLevelIntentRadioButtonEventFactory({
            path: this._path,
            parentAbsoluteLocation: this._parentAbsoluteLocation,
            data
        });
    }
    /**
     * Creates a new instance of EmbeddedArticleEventFactory
     * @param {Object} data - The required metadata for this element node.
     * @param {string} data.identifier- article slug
     * @returns {EmbeddedArticleEventFactory}  A new instance of EmbeddedArticleEventFactory
     */
    embeddedArticleFactory(data) {
        return new WebSupportContactUsArticleEventFactory.EmbeddedArticleEventFactory({
            path: this._path,
            parentAbsoluteLocation: this._parentAbsoluteLocation,
            data
        });
    }
    /**
     * Creates a new instance of CtaButtonContainerEventFactory
     * @returns {CtaButtonContainerEventFactory}  A new instance of CtaButtonContainerEventFactory
     */
    ctaButtonContainerFactory() {
        return new WebSupportContactUsArticleEventFactory.CtaButtonContainerEventFactory({
            path: this._path,
            parentAbsoluteLocation: this._parentAbsoluteLocation
        });
    }
    _getCurrentLocation() {
        return {
            pathNodes: this._path,
            specMode: [SPECIFICATION_MODE, ...[...Array(this._path.length - 1)].map(() => '')],
            specVersion: [SPECIFICATION_VERSION, ...[...Array(this._path.length - 1)].map(() => '')]
        };
    }
    getAbsoluteLocation() {
        const parentLocations = this._parentAbsoluteLocation?.locations;
        return {
            locations: [
                ...(parentLocations || []),
                this._getCurrentLocation()
            ],
        };
    }
}
(function (WebSupportContactUsArticleEventFactory) {
    /**
     * Create TopLevelIntentRadioButtonEventFactory class with path
     * @param path to this node
     */
    class TopLevelIntentRadioButtonEventFactory {
        constructor({ path, parentAbsoluteLocation, data }) {
            this._path = path.concat({
                ...data,
                name: "top_level_intent_radio_button"
            });
            if (parentAbsoluteLocation) {
                this._parentAbsoluteLocation = parentAbsoluteLocation;
            }
        }
        _getCurrentLocation() {
            return {
                pathNodes: this._path,
                specMode: [SPECIFICATION_MODE, ...[...Array(this._path.length - 1)].map(() => '')],
                specVersion: [SPECIFICATION_VERSION, ...[...Array(this._path.length - 1)].map(() => '')]
            };
        }
        getAbsoluteLocation() {
            const parentLocations = this._parentAbsoluteLocation?.locations;
            return {
                locations: [
                    ...(parentLocations || []),
                    this._getCurrentLocation()
                ],
            };
        }
        /**
         * Create interaction for hit ui_reveal action.
         */
        hitUiReveal() {
            const data = {
                actionName: "ui_reveal",
                actionVersion: 1,
                app: APP,
                generatorVersion: GENERATOR_VERSION,
                interactionType: "hit",
                specificationMode: SPECIFICATION_MODE,
                specificationVersion: SPECIFICATION_VERSION,
                annotatorConfigurationVersion: '',
                annotatorVersion: '',
                location: this._getCurrentLocation(),
                parentAbsoluteLocation: this._parentAbsoluteLocation
            };
            return data;
        }
    }
    WebSupportContactUsArticleEventFactory.TopLevelIntentRadioButtonEventFactory = TopLevelIntentRadioButtonEventFactory;
})(WebSupportContactUsArticleEventFactory || (WebSupportContactUsArticleEventFactory = {}));
(function (WebSupportContactUsArticleEventFactory) {
    /**
     * Create SecondLevelIntentRadioButtonEventFactory class with path
     * @param path to this node
     */
    class SecondLevelIntentRadioButtonEventFactory {
        constructor({ path, parentAbsoluteLocation, data }) {
            this._path = path.concat({
                ...data,
                name: "second_level_intent_radio_button"
            });
            if (parentAbsoluteLocation) {
                this._parentAbsoluteLocation = parentAbsoluteLocation;
            }
        }
        _getCurrentLocation() {
            return {
                pathNodes: this._path,
                specMode: [SPECIFICATION_MODE, ...[...Array(this._path.length - 1)].map(() => '')],
                specVersion: [SPECIFICATION_VERSION, ...[...Array(this._path.length - 1)].map(() => '')]
            };
        }
        getAbsoluteLocation() {
            const parentLocations = this._parentAbsoluteLocation?.locations;
            return {
                locations: [
                    ...(parentLocations || []),
                    this._getCurrentLocation()
                ],
            };
        }
        /**
         * Create interaction for hit ui_reveal action.
         */
        hitUiReveal() {
            const data = {
                actionName: "ui_reveal",
                actionVersion: 1,
                app: APP,
                generatorVersion: GENERATOR_VERSION,
                interactionType: "hit",
                specificationMode: SPECIFICATION_MODE,
                specificationVersion: SPECIFICATION_VERSION,
                annotatorConfigurationVersion: '',
                annotatorVersion: '',
                location: this._getCurrentLocation(),
                parentAbsoluteLocation: this._parentAbsoluteLocation
            };
            return data;
        }
        /**
         * Create impression for SecondLevelIntentRadioButtonEventFactory.
         */
        impression() {
            const data = {
                app: APP,
                generatorVersion: GENERATOR_VERSION,
                specificationVersion: SPECIFICATION_VERSION,
                specificationMode: SPECIFICATION_MODE,
                annotatorConfigurationVersion: '',
                annotatorVersion: '',
                location: this._getCurrentLocation(),
                parentAbsoluteLocation: this._parentAbsoluteLocation
            };
            return data;
        }
    }
    WebSupportContactUsArticleEventFactory.SecondLevelIntentRadioButtonEventFactory = SecondLevelIntentRadioButtonEventFactory;
})(WebSupportContactUsArticleEventFactory || (WebSupportContactUsArticleEventFactory = {}));
(function (WebSupportContactUsArticleEventFactory) {
    /**
     * Create EmbeddedArticleEventFactory class with path
     * @param path to this node
     */
    class EmbeddedArticleEventFactory {
        constructor({ path, parentAbsoluteLocation, data }) {
            this._path = path.concat({
                ...data,
                name: "embedded_article"
            });
            if (parentAbsoluteLocation) {
                this._parentAbsoluteLocation = parentAbsoluteLocation;
            }
        }
        _getCurrentLocation() {
            return {
                pathNodes: this._path,
                specMode: [SPECIFICATION_MODE, ...[...Array(this._path.length - 1)].map(() => '')],
                specVersion: [SPECIFICATION_VERSION, ...[...Array(this._path.length - 1)].map(() => '')]
            };
        }
        getAbsoluteLocation() {
            const parentLocations = this._parentAbsoluteLocation?.locations;
            return {
                locations: [
                    ...(parentLocations || []),
                    this._getCurrentLocation()
                ],
            };
        }
        /**
         * Create impression for EmbeddedArticleEventFactory.
         */
        impression() {
            const data = {
                app: APP,
                generatorVersion: GENERATOR_VERSION,
                specificationVersion: SPECIFICATION_VERSION,
                specificationMode: SPECIFICATION_MODE,
                annotatorConfigurationVersion: '',
                annotatorVersion: '',
                location: this._getCurrentLocation(),
                parentAbsoluteLocation: this._parentAbsoluteLocation
            };
            return data;
        }
    }
    WebSupportContactUsArticleEventFactory.EmbeddedArticleEventFactory = EmbeddedArticleEventFactory;
})(WebSupportContactUsArticleEventFactory || (WebSupportContactUsArticleEventFactory = {}));
(function (WebSupportContactUsArticleEventFactory) {
    /**
     * Create CtaButtonContainerEventFactory class with path
     * @param path to this node
     */
    class CtaButtonContainerEventFactory {
        constructor({ path, parentAbsoluteLocation, data }) {
            this._path = path.concat({
                name: "cta_button_container"
            });
            if (parentAbsoluteLocation) {
                this._parentAbsoluteLocation = parentAbsoluteLocation;
            }
        }
        /**
         * Creates a new instance of SelfserveLinkButtonEventFactory
         * @param {Object} data - The required metadata for this element node.
         * @param {string} data.uri- Destination where the user will be able to self service their issue
         * @returns {SelfserveLinkButtonEventFactory}  A new instance of SelfserveLinkButtonEventFactory
         */
        selfserveLinkButtonFactory(data) {
            return new WebSupportContactUsArticleEventFactory.CtaButtonContainerEventFactory.SelfserveLinkButtonEventFactory({
                path: this._path,
                parentAbsoluteLocation: this._parentAbsoluteLocation,
                data
            });
        }
        /**
         * Creates a new instance of ShowMoreButtonEventFactory
         * @returns {ShowMoreButtonEventFactory}  A new instance of ShowMoreButtonEventFactory
         */
        showMoreButtonFactory() {
            return new WebSupportContactUsArticleEventFactory.CtaButtonContainerEventFactory.ShowMoreButtonEventFactory({
                path: this._path,
                parentAbsoluteLocation: this._parentAbsoluteLocation
            });
        }
        /**
         * Creates a new instance of SupportChatLinkButtonEventFactory
         * @returns {SupportChatLinkButtonEventFactory}  A new instance of SupportChatLinkButtonEventFactory
         */
        supportChatLinkButtonFactory() {
            return new WebSupportContactUsArticleEventFactory.CtaButtonContainerEventFactory.SupportChatLinkButtonEventFactory({
                path: this._path,
                parentAbsoluteLocation: this._parentAbsoluteLocation
            });
        }
        /**
         * Creates a new instance of CommunityLinkButtonEventFactory
         * @param {Object} data - The required metadata for this element node.
         * @param {string} data.uri- A link to a specific community thread or the link to the landing page, if no link was specified in the source.
         * @returns {CommunityLinkButtonEventFactory}  A new instance of CommunityLinkButtonEventFactory
         */
        communityLinkButtonFactory(data) {
            return new WebSupportContactUsArticleEventFactory.CtaButtonContainerEventFactory.CommunityLinkButtonEventFactory({
                path: this._path,
                parentAbsoluteLocation: this._parentAbsoluteLocation,
                data
            });
        }
        _getCurrentLocation() {
            return {
                pathNodes: this._path,
                specMode: [SPECIFICATION_MODE, ...[...Array(this._path.length - 1)].map(() => '')],
                specVersion: [SPECIFICATION_VERSION, ...[...Array(this._path.length - 1)].map(() => '')]
            };
        }
        getAbsoluteLocation() {
            const parentLocations = this._parentAbsoluteLocation?.locations;
            return {
                locations: [
                    ...(parentLocations || []),
                    this._getCurrentLocation()
                ],
            };
        }
        /**
         * Create impression for CtaButtonContainerEventFactory.
         */
        impression() {
            const data = {
                app: APP,
                generatorVersion: GENERATOR_VERSION,
                specificationVersion: SPECIFICATION_VERSION,
                specificationMode: SPECIFICATION_MODE,
                annotatorConfigurationVersion: '',
                annotatorVersion: '',
                location: this._getCurrentLocation(),
                parentAbsoluteLocation: this._parentAbsoluteLocation
            };
            return data;
        }
    }
    WebSupportContactUsArticleEventFactory.CtaButtonContainerEventFactory = CtaButtonContainerEventFactory;
})(WebSupportContactUsArticleEventFactory || (WebSupportContactUsArticleEventFactory = {}));
(function (WebSupportContactUsArticleEventFactory) {
    var CtaButtonContainerEventFactory;
    (function (CtaButtonContainerEventFactory) {
        /**
         * Create SelfserveLinkButtonEventFactory class with path
         * @param path to this node
         */
        class SelfserveLinkButtonEventFactory {
            constructor({ path, parentAbsoluteLocation, data }) {
                this._path = path.concat({
                    ...data,
                    name: "selfserve_link_button"
                });
                if (parentAbsoluteLocation) {
                    this._parentAbsoluteLocation = parentAbsoluteLocation;
                }
            }
            _getCurrentLocation() {
                return {
                    pathNodes: this._path,
                    specMode: [SPECIFICATION_MODE, ...[...Array(this._path.length - 1)].map(() => '')],
                    specVersion: [SPECIFICATION_VERSION, ...[...Array(this._path.length - 1)].map(() => '')]
                };
            }
            getAbsoluteLocation() {
                const parentLocations = this._parentAbsoluteLocation?.locations;
                return {
                    locations: [
                        ...(parentLocations || []),
                        this._getCurrentLocation()
                    ],
                };
            }
            /**
             * Create interaction for hit ui_navigate action.
           * @param destination the destination field
             */
            hitUiNavigate({ destination }) {
                const data = {
                    actionParameterNames: ['destination'],
                    actionParameterValues: [destination.toString()],
                    actionName: "ui_navigate",
                    actionVersion: 1,
                    app: APP,
                    generatorVersion: GENERATOR_VERSION,
                    interactionType: "hit",
                    specificationMode: SPECIFICATION_MODE,
                    specificationVersion: SPECIFICATION_VERSION,
                    annotatorConfigurationVersion: '',
                    annotatorVersion: '',
                    location: this._getCurrentLocation(),
                    parentAbsoluteLocation: this._parentAbsoluteLocation
                };
                return data;
            }
            /**
             * Create impression for SelfserveLinkButtonEventFactory.
             */
            impression() {
                const data = {
                    app: APP,
                    generatorVersion: GENERATOR_VERSION,
                    specificationVersion: SPECIFICATION_VERSION,
                    specificationMode: SPECIFICATION_MODE,
                    annotatorConfigurationVersion: '',
                    annotatorVersion: '',
                    location: this._getCurrentLocation(),
                    parentAbsoluteLocation: this._parentAbsoluteLocation
                };
                return data;
            }
        }
        CtaButtonContainerEventFactory.SelfserveLinkButtonEventFactory = SelfserveLinkButtonEventFactory;
    })(CtaButtonContainerEventFactory = WebSupportContactUsArticleEventFactory.CtaButtonContainerEventFactory || (WebSupportContactUsArticleEventFactory.CtaButtonContainerEventFactory = {}));
})(WebSupportContactUsArticleEventFactory || (WebSupportContactUsArticleEventFactory = {}));
(function (WebSupportContactUsArticleEventFactory) {
    var CtaButtonContainerEventFactory;
    (function (CtaButtonContainerEventFactory) {
        /**
         * Create ShowMoreButtonEventFactory class with path
         * @param path to this node
         */
        class ShowMoreButtonEventFactory {
            constructor({ path, parentAbsoluteLocation, data }) {
                this._path = path.concat({
                    name: "show_more_button"
                });
                if (parentAbsoluteLocation) {
                    this._parentAbsoluteLocation = parentAbsoluteLocation;
                }
            }
            _getCurrentLocation() {
                return {
                    pathNodes: this._path,
                    specMode: [SPECIFICATION_MODE, ...[...Array(this._path.length - 1)].map(() => '')],
                    specVersion: [SPECIFICATION_VERSION, ...[...Array(this._path.length - 1)].map(() => '')]
                };
            }
            getAbsoluteLocation() {
                const parentLocations = this._parentAbsoluteLocation?.locations;
                return {
                    locations: [
                        ...(parentLocations || []),
                        this._getCurrentLocation()
                    ],
                };
            }
            /**
             * Create interaction for hit ui_reveal action.
             */
            hitUiReveal() {
                const data = {
                    actionName: "ui_reveal",
                    actionVersion: 1,
                    app: APP,
                    generatorVersion: GENERATOR_VERSION,
                    interactionType: "hit",
                    specificationMode: SPECIFICATION_MODE,
                    specificationVersion: SPECIFICATION_VERSION,
                    annotatorConfigurationVersion: '',
                    annotatorVersion: '',
                    location: this._getCurrentLocation(),
                    parentAbsoluteLocation: this._parentAbsoluteLocation
                };
                return data;
            }
            /**
             * Create impression for ShowMoreButtonEventFactory.
             */
            impression() {
                const data = {
                    app: APP,
                    generatorVersion: GENERATOR_VERSION,
                    specificationVersion: SPECIFICATION_VERSION,
                    specificationMode: SPECIFICATION_MODE,
                    annotatorConfigurationVersion: '',
                    annotatorVersion: '',
                    location: this._getCurrentLocation(),
                    parentAbsoluteLocation: this._parentAbsoluteLocation
                };
                return data;
            }
        }
        CtaButtonContainerEventFactory.ShowMoreButtonEventFactory = ShowMoreButtonEventFactory;
    })(CtaButtonContainerEventFactory = WebSupportContactUsArticleEventFactory.CtaButtonContainerEventFactory || (WebSupportContactUsArticleEventFactory.CtaButtonContainerEventFactory = {}));
})(WebSupportContactUsArticleEventFactory || (WebSupportContactUsArticleEventFactory = {}));
(function (WebSupportContactUsArticleEventFactory) {
    var CtaButtonContainerEventFactory;
    (function (CtaButtonContainerEventFactory) {
        /**
         * Create SupportChatLinkButtonEventFactory class with path
         * @param path to this node
         */
        class SupportChatLinkButtonEventFactory {
            constructor({ path, parentAbsoluteLocation, data }) {
                this._path = path.concat({
                    name: "support_chat_link_button"
                });
                if (parentAbsoluteLocation) {
                    this._parentAbsoluteLocation = parentAbsoluteLocation;
                }
            }
            _getCurrentLocation() {
                return {
                    pathNodes: this._path,
                    specMode: [SPECIFICATION_MODE, ...[...Array(this._path.length - 1)].map(() => '')],
                    specVersion: [SPECIFICATION_VERSION, ...[...Array(this._path.length - 1)].map(() => '')]
                };
            }
            getAbsoluteLocation() {
                const parentLocations = this._parentAbsoluteLocation?.locations;
                return {
                    locations: [
                        ...(parentLocations || []),
                        this._getCurrentLocation()
                    ],
                };
            }
            /**
             * Create interaction for hit ui_navigate action.
           * @param destination the destination field
             */
            hitUiNavigate({ destination }) {
                const data = {
                    actionParameterNames: ['destination'],
                    actionParameterValues: [destination.toString()],
                    actionName: "ui_navigate",
                    actionVersion: 1,
                    app: APP,
                    generatorVersion: GENERATOR_VERSION,
                    interactionType: "hit",
                    specificationMode: SPECIFICATION_MODE,
                    specificationVersion: SPECIFICATION_VERSION,
                    annotatorConfigurationVersion: '',
                    annotatorVersion: '',
                    location: this._getCurrentLocation(),
                    parentAbsoluteLocation: this._parentAbsoluteLocation
                };
                return data;
            }
            /**
             * Create impression for SupportChatLinkButtonEventFactory.
             */
            impression() {
                const data = {
                    app: APP,
                    generatorVersion: GENERATOR_VERSION,
                    specificationVersion: SPECIFICATION_VERSION,
                    specificationMode: SPECIFICATION_MODE,
                    annotatorConfigurationVersion: '',
                    annotatorVersion: '',
                    location: this._getCurrentLocation(),
                    parentAbsoluteLocation: this._parentAbsoluteLocation
                };
                return data;
            }
        }
        CtaButtonContainerEventFactory.SupportChatLinkButtonEventFactory = SupportChatLinkButtonEventFactory;
    })(CtaButtonContainerEventFactory = WebSupportContactUsArticleEventFactory.CtaButtonContainerEventFactory || (WebSupportContactUsArticleEventFactory.CtaButtonContainerEventFactory = {}));
})(WebSupportContactUsArticleEventFactory || (WebSupportContactUsArticleEventFactory = {}));
(function (WebSupportContactUsArticleEventFactory) {
    var CtaButtonContainerEventFactory;
    (function (CtaButtonContainerEventFactory) {
        /**
         * Create CommunityLinkButtonEventFactory class with path
         * @param path to this node
         */
        class CommunityLinkButtonEventFactory {
            constructor({ path, parentAbsoluteLocation, data }) {
                this._path = path.concat({
                    ...data,
                    name: "community_link_button"
                });
                if (parentAbsoluteLocation) {
                    this._parentAbsoluteLocation = parentAbsoluteLocation;
                }
            }
            _getCurrentLocation() {
                return {
                    pathNodes: this._path,
                    specMode: [SPECIFICATION_MODE, ...[...Array(this._path.length - 1)].map(() => '')],
                    specVersion: [SPECIFICATION_VERSION, ...[...Array(this._path.length - 1)].map(() => '')]
                };
            }
            getAbsoluteLocation() {
                const parentLocations = this._parentAbsoluteLocation?.locations;
                return {
                    locations: [
                        ...(parentLocations || []),
                        this._getCurrentLocation()
                    ],
                };
            }
            /**
             * Create interaction for hit ui_navigate action.
           * @param destination the destination field
             */
            hitUiNavigate({ destination }) {
                const data = {
                    actionParameterNames: ['destination'],
                    actionParameterValues: [destination.toString()],
                    actionName: "ui_navigate",
                    actionVersion: 1,
                    app: APP,
                    generatorVersion: GENERATOR_VERSION,
                    interactionType: "hit",
                    specificationMode: SPECIFICATION_MODE,
                    specificationVersion: SPECIFICATION_VERSION,
                    annotatorConfigurationVersion: '',
                    annotatorVersion: '',
                    location: this._getCurrentLocation(),
                    parentAbsoluteLocation: this._parentAbsoluteLocation
                };
                return data;
            }
            /**
             * Create impression for CommunityLinkButtonEventFactory.
             */
            impression() {
                const data = {
                    app: APP,
                    generatorVersion: GENERATOR_VERSION,
                    specificationVersion: SPECIFICATION_VERSION,
                    specificationMode: SPECIFICATION_MODE,
                    annotatorConfigurationVersion: '',
                    annotatorVersion: '',
                    location: this._getCurrentLocation(),
                    parentAbsoluteLocation: this._parentAbsoluteLocation
                };
                return data;
            }
        }
        CtaButtonContainerEventFactory.CommunityLinkButtonEventFactory = CommunityLinkButtonEventFactory;
    })(CtaButtonContainerEventFactory = WebSupportContactUsArticleEventFactory.CtaButtonContainerEventFactory || (WebSupportContactUsArticleEventFactory.CtaButtonContainerEventFactory = {}));
})(WebSupportContactUsArticleEventFactory || (WebSupportContactUsArticleEventFactory = {}));
